<div class="persons-container">
  <div class="header">
    <h2 >Twoje wnioski</h2>
    <div class="header-buttons">

      <button mat-raised-button class="custom-button" (click)="addNewPerson()">
        <mat-icon>person_add</mat-icon>
        Dodaj wniosek
      </button>
    </div>
  </div>

  @if (loading) {
    <div class="loading-container">
      <mat-progress-spinner diameter="50"></mat-progress-spinner>
      <p>Ładowanie wniosków...</p>
    </div>
  }

  @if (!loading && persons.length === 0) {
    <div class="no-data">
      <mat-icon>person_off</mat-icon>
      <p>Brak wniosków do wyświetlenia</p>
    </div>
  }


  @if (!loading && persons.length > 0) {
    <div class="table-container">
      <table mat-table [dataSource]="persons" class="persons-table" multiTemplateDataRows>
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Imię i Nazwisko</th>
          <td mat-cell *matCellDef="let person">
            <div class="person-name">
              <strong>{{person.name}} {{person.surname}}</strong>
            </div>
          </td>
        </ng-container>

        <!-- Cards Column -->
        <ng-container matColumnDef="cards">
          <th mat-header-cell *matHeaderCellDef>Karty</th>
          <td mat-cell *matCellDef="let person">
            <div class="cards-info">
              @if (getActiveCards(person); as activeCards) {
                @if (activeCards.length > 0) {
                  <span class="cards-count">
                    <mat-icon>credit_card</mat-icon>
                    {{activeCards.length}} kart{{activeCards.length === 1 ? 'a' : activeCards.length < 5 ? 'y' : ''}}
                  </span>
                }
                @if (activeCards.length === 0) {
                  <span class="no-cards">
                    <mat-icon>credit_card_off</mat-icon>
                    Brak kart
                  </span>
                }
              }

              @if (person.default === 1) {
                <mat-icon title="Osoba domyślna">check_circle</mat-icon>
              }
            </div>
          </td>
        </ng-container>
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Akcje</th>
          <td mat-cell *matCellDef="let person">
            <div class="actions">
              <button mat-raised-button class="custom-button action-edit-button" (click)="viewPersonDetails(person)">
                <mat-icon>edit</mat-icon>
                Edytuj
              </button>
            </div>
          </td>
        </ng-container>
        <!-- Stats span row column -->
        <ng-container matColumnDef="statsDetail">
          <td mat-cell *matCellDef="let person" [attr.colspan]="displayedColumns.length" class="stats-cell">
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="person-row"></tr>
        <tr mat-row *matRowDef="let row; columns: ['statsDetail']; when: hasAggregationData" class="stats-row"></tr>
      </table>
    </div>
  }
</div>
